export enum ContactStage {
  SUBSCRIBER = "subscriber",
  LEAD = "lead",
  INTEREST_IDENTIFIED = "2055750850",
  PHONE_PROSPECTING = "2055750851",
  ONBOARDING = "2055488722",
  ACCESS_SIGNUP = "2055488723",
  ACCESS = "2055488724",
  FIRST_ORDER_SIGNUP = "2055750853",
  FIRST_ORDER = "2055488726",
  LOST = "2060167406",
  CLIENT = "2124652755",
}

export const CONTACT_STAGES = Object.values(ContactStage) as [
  ContactStage,
  ...ContactStage[],
];

export enum ContactOrigin {
  ONBOARDING = "Formulaire Onboarding Client",
}
export const CONTACT_ORIGINS = Object.values(ContactOrigin) as [
  ContactOrigin,
  ...ContactOrigin[],
];

export const CONTACT_JOB_TYPES = [
  {
    label: "Gestionnaire d’actifs immobilier",
    value: "gestionnaire_actifs_immobilier",
  },
  {
    label: "Gestionnaire d’actifs tertiaires",
    value: "gestionnaire_actifs_tertiaires",
  },
  {
    label: "Gestionnaire d’actifs immobiliers Senior",
    value: "gestionnaire_actifs_immobiliers_senior",
  },
  {
    label: "Gestionnaire d’actifs tertiaires Senior",
    value: "gestionnaire_actifs_tertiaires_senior",
  },
  {
    label: "Directeur de l’asset management",
    value: "directeur_asset_management",
  },
  { label: "Gestionnaire de copropriétés", value: "gestionnaire_copropriétés" },
  { label: "Responsable technique", value: "responsable_technique" },
  { label: "Directeur technique", value: "directeur_technique" },
  {
    label: "Responsable de programmes immobiliers",
    value: "responsable_programmes_immobiliers",
  },
  { label: "Property manager", value: "property_manager" },
  { label: "Propriétaire exploitant", value: "Propriétaire exploitant" },
  { label: "Autre", value: "Autre" },
] as const;

export const CONTACT_ACTIVITY_SECTORS = [
  { label: "Architecte / BET", value: "architecte_bet" },
  { label: "Autre", value: "Autre" },
  { label: "Éducation", value: "Education" },
  { label: "Entreprise de travaux", value: "entreprise_travaux" },
  {
    label: "Gestion d’actifs immobiliers",
    value: "gestion_actifs_immobiliers",
  },
  { label: "Gestion de copropriétés", value: "gestion_coproprietes" },
  { label: "Santé", value: "sante" },
  { label: "Hôtellerie-Restauration", value: "hotellerie_restauration" },
] as const;
